// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__-b_fm","colMaxWidth":"Table_colMaxWidth__12CiA"};